import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Logo } from '../../../../../components/logo/logo';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { Router, RouterOutlet } from '@angular/router';
import { cursoResponseInterface } from '../../../../../interfaces/curso/curso-response.interface';
import { CommonModule, DatePipe } from '@angular/common';
import { GeraPagamentoService } from '../../../../../services/curso/gera-pagamento.service';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { DadosCursoService } from '../../../../../services/curso/dados-curso.service';
import { DadosCursoResponseInterface } from '../../../../../interfaces/curso/dados-curso-response.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { ParamCursoDataService } from '../../../../../services/curso/param-curso-data.service';
import { ThemeMode, ThemeService } from '../../../../../services/theme.service';


@Component({
  selector: 'app-conclusao-ficha',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    Logo,
    MatIconModule,
    DatePipe,
    CommonModule,
    MatProgressSpinnerModule,
    TranslatePipe,
    RouterOutlet
],
  templateUrl: './conclusao-ficha.html',
  styleUrl: './conclusao-ficha.css'
})
export class ConclusaoFicha {

  nome_aluno: string = '';
  nome_curso: string = '';
  data_inclusao: string = '';
  posicao: string = '';
  qtd_vagas: string = '';
  taxa_inscricao: string = '';
  dadosCurso! : DadosCursoResponseInterface;
  moro_no_brasil: boolean = false;
  termo: string = '';
  gratuito: boolean = false;

  loading: boolean = false;

  termo_aceito: boolean = false;
  url_boleto:string = '';

  dados_salvos!: cursoResponseInterface;
  _router = inject(Router)
  _geraPagamento = inject(GeraPagamentoService);
  _dadosCurso = inject(DadosCursoService);
  _paramCursoData = inject(ParamCursoDataService);
  private _originalTheme: ThemeMode = 'system';
  private _themeService = inject(ThemeService);

  constructor(){

    this.nome_aluno = this._paramCursoData.getDataSubmit().pessoa.PF_NOME;
    this.nome_curso = this._paramCursoData.nome_curso;
    this.posicao = this._paramCursoData.getDataSubmit().pessoa.posicao.toString();
    this.data_inclusao = this._paramCursoData.getDataSubmit().pessoa.DI_DATAHORA;
  }

  ngOnInit(){

    // Store original theme and force light theme
    this._originalTheme = this._themeService.themeMode();
    this._themeService.setTheme('light');
  }

  ngOnDestroy() {

    // Restore original theme when leaving the page
    this._themeService.setTheme(this._originalTheme);
  }

}
